import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  VStack,
  RadioGroup,
  Radio,
  FormControl,
  FormLabel,
  Textarea,
  FormHelperText,
} from '@chakra-ui/react';

const DocumentVerificationModal = ({ isOpen, onClose, onVerify }) => {
  const [status, setStatus] = useState('APPROVED');
  const [reason, setReason] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await onVerify({
        status,
        reason: status === 'REJECTED' ? reason : ''
      });
      onClose();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
      <ModalOverlay backdropFilter="blur(4px)"/>
      <ModalContent>
        <ModalHeader>Document Verification</ModalHeader>
        <ModalBody>
          <VStack spacing={6} align="stretch">
            <FormControl>
              <FormLabel fontWeight="medium">Verification Status</FormLabel>
              <RadioGroup onChange={setStatus} value={status}>
                <VStack align="start" spacing={3}>
                  <Radio value="APPROVED">
                    <Text>Approve Documents</Text>
                  </Radio>
                  <Radio value="REJECTED">
                    <Text>Reject Documents</Text>
                  </Radio>
                </VStack>
              </RadioGroup>
            </FormControl>

            {status === 'REJECTED' && (
              <FormControl isRequired>
                <FormLabel>Rejection Reason</FormLabel>
                <Textarea
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="Please provide a clear explanation for the rejection"
                  maxLength={500}
                  rows={4}
                />
                <FormHelperText>
                  {reason.length}/500 characters • This message will be sent to the user
                </FormHelperText>
              </FormControl>
            )}
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button 
            variant="ghost" 
            mr={3} 
            onClick={onClose}
            isDisabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button 
            colorScheme={status === 'APPROVED' ? 'green' : 'red'}
            onClick={handleSubmit}
            isDisabled={(status === 'REJECTED' && !reason) || isSubmitting}
            isLoading={isSubmitting}
            loadingText={status === 'APPROVED' ? 'Approving...' : 'Rejecting...'}
          >
            {status === 'APPROVED' ? 'Approve Documents' : 'Reject Documents'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DocumentVerificationModal;
